module.exports = __webpack_public_path__ + "img/more-icon.729bfccf.svg";